import { useMutation } from '@tanstack/react-query'
import { useGlobalError } from '../context/GlobalError'
import { mutationLogout } from '../api/mutations'

export const useLogout = () => {
  const { addError } = useGlobalError()
  const { mutate: handleLogout } = useMutation(mutationLogout, {
    onError: () => {
      addError('Failed to logout', 500)
    },
    onSuccess: () => {
      delete localStorage.csrf
      delete localStorage.access
      window.location.href = '/login'
    },
  })

  return handleLogout
}
